import { STUDY_VERSION_ID_URL_PLACEHOLDER } from 'utils/constants'
import { buildStudyRoutePath } from 'utils/navigation'
import { getStudyRoleInfo } from '../../routes/CreateStudy/utils/studyUtils'

export const STUDY_LIST_NAV = {
  MODAL: 'modal',
  GO: 'go',
  FETCH_THEN_GO: 'fetch-then-go',
}

export const shouldOpenSelectStudyVersionModal = ({
  hasStudyPromotion,
  isAllowedToSelectStudyVersion,
}) => Boolean(hasStudyPromotion && isAllowedToSelectStudyVersion)

export const getStudyVersionDestinationPath = (studyId, versionId, redirectPath) =>
  buildStudyRoutePath(studyId, versionId, redirectPath)

export const isStudyTrackUnavailable = ({
  isUATRole,
  isDEVRole,
  isLiveRole,
  uatVersion,
  devVersion,
  liveVersion,
}) => (isUATRole && !uatVersion) || (isDEVRole && !devVersion) || (isLiveRole && !liveVersion)

export const resolveStudyListNavigation = ({
  hasStudyPromotion,
  userPermissions,
  studyId,
  versions,
}) => {
  const roleInfo = getStudyRoleInfo(userPermissions, studyId, versions || [])

  if (
    shouldOpenSelectStudyVersionModal({
      hasStudyPromotion,
      isAllowedToSelectStudyVersion: roleInfo.isAllowedToSelectStudyVersion,
    })
  ) {
    return { action: STUDY_LIST_NAV.MODAL, roleInfo }
  }

  if (!hasStudyPromotion) {
    return {
      action: STUDY_LIST_NAV.GO,
      versionId: STUDY_VERSION_ID_URL_PLACEHOLDER,
      roleInfo,
    }
  }

  if (!Array.isArray(versions)) {
    return { action: STUDY_LIST_NAV.FETCH_THEN_GO, roleInfo }
  }

  return {
    action: STUDY_LIST_NAV.GO,
    versionId: roleInfo.studyVersionID,
    unavailable: isStudyTrackUnavailable(roleInfo),
    roleInfo,
  }
}

export const runStudyListNavigation = ({
  hasStudyPromotion,
  userPermissions,
  studyId,
  fetchStudyVersionList,
  onModal,
  onGo,
  onUnavailable,
}) => {
  const decision = resolveStudyListNavigation({
    hasStudyPromotion,
    userPermissions,
    studyId,
  })

  if (decision.action === STUDY_LIST_NAV.MODAL) {
    fetchStudyVersionList(studyId)
    onModal()
    return
  }

  if (decision.action === STUDY_LIST_NAV.GO) {
    onGo(decision.versionId)
    return
  }

  return Promise.resolve(fetchStudyVersionList(studyId)).then(list => {
    const next = resolveStudyListNavigation({
      hasStudyPromotion,
      userPermissions,
      studyId,
      versions: Array.isArray(list) ? list : [],
    })
    if (next.unavailable) {
      onUnavailable()
      return
    }
    onGo(next.versionId)
  })
}
